import React from "react";
import "./notesSkeleton.scss";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
import { URButtonSkeleton } from "./skeletonWidgets/buttonSkeleton";
function URNotesSkeleton(props: any) {
  return (
    <>
      <div className="notesSkeleton">
        <div className="btnSec">
          <URLineSkeleton className='line lineThick size30'/>
          <URButtonSkeleton className='skeletonBtn' />
        </div>
        <div className="filesBox">
          <div className="boxFirstLine">
            <div className="notesIconbtn"><b></b></div>
            <div className="notesLine">
              <URLineSkeleton className='line lineThick size60'/>
              <URLineSkeleton className='line lineThin size70'/>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export {
  URNotesSkeleton
};